import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'm-top-usuarios',
  templateUrl: './top-usuarios.component.html',
  styleUrls: ['./top-usuarios.component.scss']
})
export class TopUsuariosComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
